import { useState } from "react";

import PasswordResetForm from "../../components/auth/PasswordReset/Form";

const Reset = () => {
  const [passwordResetIsOpen, setPasswordResetIsOpen] = useState(true);

  return (
    <>
      {passwordResetIsOpen && (
        <PasswordResetForm setPasswordResetIsOpen={setPasswordResetIsOpen} />
      )}
    </>
  );
};

export default Reset;
